import { useEffect, useRef } from 'react';

const millisecondsUntilNextLocalDay = (now: Date): number => {
  const nextDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1
  );
  return nextDay.getTime() - now.getTime();
};

export const useDailyPuzzleRollover = (
  enabled: boolean,
  onDateCheck: (now: Date) => void
): void => {
  const callbackRef = useRef(onDateCheck);
  callbackRef.current = onDateCheck;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const scheduleNextCheck = () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
      const now = new Date();
      timeoutId = setTimeout(handleDateCheck, millisecondsUntilNextLocalDay(now) + 1);
    };

    const handleDateCheck = () => {
      callbackRef.current(new Date());
      scheduleNextCheck();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleDateCheck();
      }
    };

    window.addEventListener('focus', handleDateCheck);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    scheduleNextCheck();

    return () => {
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
      window.removeEventListener('focus', handleDateCheck);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [enabled]);
};
